module.exports = __webpack_public_path__ + "img/freespin3_multiplier18.3c784b68.png";